export default __webpack_public_path__ + "static/media/brakekit-red.f1699005.webp";